export default __webpack_public_path__ + "img/ec03c2f210bbf067bf82d0bf7cb69ac1.svg";